import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class MailboxService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  getFolders(account_id, query?: any) {
    return this.get('/mail/list-folder/' + account_id, query);
  }

  createFolder(account_id, body: any) {
    return this.post('/mail/create-folder/' + account_id, body);
  }

  deleteFolder(account_id, folder_id) {
    return this.delete('/email/delete-folder/' + account_id + '/' + folder_id);
  }

  updateFolder(account_id, folder_id, body) {
    return this.delete('/email/update-folder/' + account_id + '/' + folder_id), body;
  }

  inbox(account_id, query?: any) {
    return this.get('/inbox/' + account_id, query);
  }

  unread(account_id, query?: any) {
    return this.get('/inbox-unread/' + account_id, query);
  }

  listSentMail(query?: any) {
    return this.get('/list-sent-mail', query);
  }

  setRead(body) {
    return this.put('/mail/set-read', body);
  }

  setDelete(body) {
    return this.put('/mail/set-delete', body);
  }
  setDeleteSent(body) {
    return this.put('/mail/set-delete-sent', body);
  }

  setDeleteForever(body) {
    return this.put('/mail/set-delete-forever', body);
  }
  setDeleteForeverSent(body) {
    return this.put('/mail/set-delete-forever-sent', body);
  }

  addMailFolder(body) {
    return this.put('/mail/add-folder', body);
  }
  removeMailFolder(body) {
    return this.put('/mail/remove-folder', body);
  }

  viewDetail(mail_id, query?: any) {
    return this.get('/mail/detail/' + mail_id, query);
  }
  viewDetailSent(mail_id, query?: any) {
    return this.get('/mail/detail-sent/' + mail_id, query);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Mailbox.service.ts